import { SberIcon } from './SberIcon'

const pngIcons: Record<
  string,
  Record<'light' | 'dark', Record<'active' | 'stopped' | 'canceled' | 'new', string>>
> = {
  '01961ff4-6d64-7162-ad77-8ca988f1702f': {
    light: {
      active: '/banks/light/amobile-green.png',
      canceled: '/banks/light/amobile-red.png',
      stopped: '/banks/light/amobile-grey.png',
      new: '/banks/light/amobile-green.png',
    },
    dark: {
      active: '/banks/dark/amobile-green.png',
      canceled: '/banks/dark/amobile-red.png',
      stopped: '/banks/dark/amobile-grey.png',
      new: '/banks/dark/amobile-green.png',
    },
  },
}

const svgIcons: Record<
  string,
  React.FC<{ status: BankIconProps['status']; className?: string }>
> = {
  'b85b1c98-5307-46c6-9acb-5ca27a21b416': SberIcon,
}

interface BankIconProps {
  status: 'active' | 'stopped' | 'canceled' | 'new'
  className?: string
  bankId?: string
}

export const BankIcon = ({ status = 'new', className, bankId }: BankIconProps) => {
  const fillColor = {
    active: 'var(--status-green-fill)',
    stopped: 'var(--status-grey-fill)',
    canceled: 'var(--status-red-fill)',
    new: '#FFF',
  }[status]

  const SvgIcon = bankId ? svgIcons[bankId] : null
  const lightSrc = bankId ? pngIcons[bankId]?.light?.[status] : null
  const darkSrc = bankId ? pngIcons[bankId]?.dark?.[status] : null

  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="40" height="40" rx="20" fill={fillColor} />

      {lightSrc && darkSrc ? (
        <>
          <image href={lightSrc} x="0" y="0" width="40" height="40" className="block dark:hidden" />
          <image href={darkSrc} x="0" y="0" width="40" height="40" className="hidden dark:block" />
        </>
      ) : SvgIcon ? (
        <SvgIcon status={status} />
      ) : null}
    </svg>
  )
}
